import React, { useState } from 'react';
import { Breadcrumb, Row, Col, Menu, Button, Popover, Spin, Select } from 'antd';
import { Column } from '@ant-design/plots';
import { queryAPIAppCountByDate, queryAPIDeveloperCountByDate } from "./gqls";
import Client from '../../../../lib/gqlClient';
import getWantTimestamp from '../../../../lib/utils/times'
import moment from 'moment-timezone';
const AppOrDeveloperChartPage = () => {
    const [isSelectAppOrDeveloperLoading, setIsSelectAppOrDeveloperLoading] = useState(false)//是否正在加载
    let isSelectAppOrDeveloper = true //true app  false  Developer
    const [appOrDeveloperSelectItem, setAppOrDeveloperSelectItem] = useState(3)//默认显示全年 1本月 2本季度 3全年
    const [time, setTime] = useState()
    const [timeList, setTimeList] = useState([{}])
    const [oneList, setOneList] = useState([])
    const [AppOrDeveloperName, setAppOrDeveloperName] = useState('新增授权App')
    const [appOrDeveloperNameItem, setAppOrDeveloperNameItem] = useState('授权App')
    React.useEffect(() => {
        setSelectTime()

    }, [])
    function setSelectTime() {
        let year = moment().utc().year();
        setTime(year)
        isGetSelectAppOrDeveloper(year)

        var list = [{}]
        list[0] = { value: '本季度', label: '本季度' }
        for (let index = 1; index <= year - 2020 + 1; index++) {
            list[index] = { value: year - index + 1, label: year - index + 1 }
        }
        list[year - 2020 + 2] = { value: '全部', label: '全部' }
        setTimeList(list)

    }
    function onClick(e) {
        console.log(e)
        switch (e.key) {
            case "1":
                //刷新授权app
                isSelectAppOrDeveloper = true
                isGetSelectAppOrDeveloper(appOrDeveloperSelectItem);
                break;
            case "2":
                //刷新授权开发者
                isSelectAppOrDeveloper = false
                isGetSelectAppOrDeveloper(appOrDeveloperSelectItem);
                break;
        }
    }
    function btnAppOrDeveloper(type) {
        if (AppOrDeveloperName === '新增授权App') {
            isSelectAppOrDeveloper = true
        } else {
            isSelectAppOrDeveloper = false
        }
        isGetSelectAppOrDeveloper(type)
    }
    function isGetSelectAppOrDeveloper(type) {
        setAppOrDeveloperSelectItem(type)
        var start = ''
        var end = ''
        let year = ''
        switch (type) {
            case '本季度':
                start = getWantTimestamp("threeMonthDayZero");
                end = getWantTimestamp("nowData");
                year = moment().utc().year();
                break;
            case '全部':
                start = moment.tz('2020-01-01T00:00:00', 'ETC/GMT+0').valueOf()
                end = getWantTimestamp("nowData")
                year = 2020
                break;
            default: {
                start = moment.tz(type + '-01-01T00:00:00', 'ETC/GMT+0').valueOf()
                end = moment.tz(type + '-12-31T23:59:59', 'ETC/GMT+0').valueOf()
                year = type
            }
        }

        setIsSelectAppOrDeveloperLoading(true)
        if (isSelectAppOrDeveloper) {
            setAppOrDeveloperName('新增授权App')
            setAppOrDeveloperNameItem('授权App')
            getAPIAppCountByDate(type, start, end, year)
        } else {
            setAppOrDeveloperName('新增授权开发者')
            setAppOrDeveloperNameItem('授权开发者')
            getAPIDeveloperCountByDate(type, start, end, year)
        }
    }
    function getAPIAppCountByDate(type, start, end, year) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrDeveloper = true
        Client(
            queryAPIAppCountByDate,
            {
                startDate: start,
                endDate: end
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.openAPIAppCountByDate
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrDeveloperLoading(false)
            }
        }).catch(e => {
            setOneList([])
            setIsSelectAppOrDeveloperLoading(false)
        })
    }
    function getAPIDeveloperCountByDate(type, start, end, year) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrDeveloper = false
        Client(
            queryAPIDeveloperCountByDate,
            {
                startDate: start,
                endDate: end
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.openAPIDeveloperCountByDate
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrDeveloperLoading(false)
            }
        }).catch(e => {
            setOneList([])
            setIsSelectAppOrDeveloperLoading(false)
        })
    }
    const onItemsMembersClick = (value) => {
        console.log(value)
        setTime(value)
        btnAppOrDeveloper(value)
    };
    return (

        <div style={{ height: '404px', padding: '0px', marginTop: '15px', backgroundColor: 'white', borderRadius: '2px' }}>

            <div style={{ height: '55px', padding: '0px', }}>
                <Row>
                    <Col span={12}>
                        <Menu defaultSelectedKeys={['1']}
                            defaultOpenKeys={['a']}
                            mode="horizontal"
                            style={{ justifyContent: 'start' }}
                            items={itemsOne}
                            onClick={onClick}
                        >
                        </Menu>
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                        <div style={{
                            marginRight: '18px', width: '200px', minHeight: '30px', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                        }}>
                            <Select
                                className='select'
                                size='middle'
                                style={{
                                    width: '200px',
                                }}
                                maxTagCount='responsive'
                                showArrow={true}
                                bordered={false}
                                placeholder="Please select"
                                onSelect={onItemsMembersClick}
                                options={timeList}
                                value={time}
                            />
                        </div>

                    </Col>
                </Row>
                <div style={{ height: '1px', backgroundColor: '#E8E8E8' }} />
            </div>
            <a style={{ marginLeft: '56px', marginTop: '24px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #2657F9' }}>{AppOrDeveloperName}</a>
            <Spin size="large" tip="Loading..." spinning={isSelectAppOrDeveloperLoading}>
                <Column {...{
                    data: oneList,
                    xField: 'type',
                    yField: 'sales',
                    color: '#2657F9',
                    columnWidthRatio: 0.4,
                    marginRatio: 0.6,
                    minColumnWidth: 30, 
                    xAxis: {
                        label: {
                            autoHide: true,
                            autoRotate: false,
                        },
                    },
                    meta: {
                        sales: {
                            alias: appOrDeveloperNameItem,
                        },
                    },
                    scrollbar: {
                        type: 'horizontal',
                      },
                }} style={{ height: '246px', marginTop: '20px', marginBottom: '33px', marginLeft: '99px', marginRight: '94px' }} />
            </Spin>

        </div>
    )

}
function getItem(label, key,) {
    return {
        key,
        label,
    };
}
const itemsOne = [
    getItem('授权App', '1'),
    getItem('授权开发者', '2'),

];
export default AppOrDeveloperChartPage